import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { Filter20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/Filter20Regular";

export function useMenuItem_Filter(setIsCMFileFilterPanelOpen: (isCMFileFilterPanelOpen: boolean) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue?.value);
  const filterFields = useSelector((state: RootState) => state.contentManagerDirectory.filterFields);
  const filterSections = useSelector((state: RootState) => state.contentManagerDirectory.filterSections);

  const menuItem_Filter = React.useMemo(() => {
    return {
      key: "filter",
      disabled: (!filterFields || filterFields?.length === 0) && (!filterSections || filterSections?.length === 0),
      // iconProps: { iconName: "Filter" },
      iconProps: {},
      onRenderIcon: () => <Filter20Regular className={menuItemIconStyles} />,
      iconOnly: true,
      tooltipHostProps: {
        content: <span>{languageStrings.Filter}</span>
      },
      onClick: () => {
        setIsCMFileFilterPanelOpen(true);
      }
    } as IContextualMenuItem;
  }, [searchValue, filterFields, filterSections]);

  return {
    menuItem_Filter
  }
}